var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _rect4, _path14, _rect5, _rect6, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.733,
    width: 35.938,
    height: 23,
    rx: 1.44,
    fill: "#1434CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.663 8.762l-2.917 6.96h-1.903l-1.436-5.554c-.087-.342-.163-.468-.428-.612-.433-.235-1.147-.455-1.776-.591l.043-.203h3.063c.39 0 .742.26.83.71l.759 4.027 1.873-4.737h1.892zm7.457 4.688c.008-1.837-2.54-1.938-2.523-2.759.006-.25.244-.515.764-.583.258-.034.969-.06 1.775.311l.316-1.475a4.837 4.837 0 00-1.684-.309c-1.78 0-3.032.946-3.042 2.3-.012 1.003.894 1.562 1.576 1.895.701.34.937.56.934.865-.005.467-.56.673-1.078.68-.905.015-1.43-.244-1.848-.439l-.327 1.525c.42.193 1.197.361 2.002.37 1.892 0 3.13-.934 3.135-2.381zm4.7 2.272h1.664l-1.453-6.96h-1.537a.82.82 0 00-.766.51l-2.702 6.45h1.89l.376-1.04h2.31l.217 1.04zm-2.01-2.466l.948-2.613.545 2.613H25.81zm-7.575-4.494l-1.488 6.96h-1.8l1.489-6.96h1.8z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.313,
    y: 0.733,
    width: 35.938,
    height: 23,
    rx: 1.44,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.638 6.204H56.93v12.054h6.708V6.204z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.356 12.231a7.715 7.715 0 012.918-6.027c-3.323-2.62-8.157-2.044-10.776 1.3-2.598 3.322-2.023 8.135 1.32 10.754a7.646 7.646 0 009.477 0 7.67 7.67 0 01-2.939-6.027z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.69 12.231a7.662 7.662 0 01-7.667 7.667 7.588 7.588 0 01-4.728-1.64c3.322-2.62 3.897-7.432 1.278-10.776a8.06 8.06 0 00-1.278-1.278c3.322-2.62 8.156-2.044 10.754 1.3a7.588 7.588 0 011.64 4.727z",
    fill: "#F79E1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.25.733h35.938v23H84.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.182 21.217l-1.594-1.778-1.656 1.778h-10.241v-8.279h-3.251l4.048-9.26h3.925l1.41 3.189v-3.19h4.906l.859 2.393.859-2.392h3.741v-1.41c0-.86-.675-1.534-1.534-1.534h-32.87c-.86 0-1.534.675-1.534 1.533V22.2c0 .858.675 1.533 1.533 1.533h32.871c.859 0 1.534-.675 1.534-1.533v-.982h-3.006z",
    fill: "#0071CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.612 20.236h2.575l-3.373-3.618 3.373-3.557h-2.514l-2.146 2.33-2.085-2.33h-2.576l3.434 3.618-3.434 3.557h2.514l2.147-2.33 2.085 2.33zM106.757 18.58v-1.104h4.048v-1.655h-4.048v-1.104h4.109V13.06h-6.072v7.175h6.072V18.58h-4.109zM118.286 12.018h1.84V4.782l-2.944.061-1.594 4.477-1.656-4.477h-3.066v7.175h1.962V6.99l1.84 5.03h1.717l1.901-5.03v5.03z",
    fill: "#0071CE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.738 4.843h-2.514l-3.189 7.175h2.146l.613-1.41h3.312l.613 1.41h2.208l-3.189-7.175zm-2.269 4.109l.981-2.33.982 2.33h-1.963zM118.409 16.434l1.778 1.962v-3.925l-1.778 1.963z",
    fill: "#0071CE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.188.733h35.938v23h-35.938z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.624 13.018l1.318-3.284h1.034l-2.111 5.014h-.513l-2.071-5.014h1.041l1.302 3.284zm-13.229-3.363c.537 0 1.027.182 1.437.54l-.497.652c-.249-.276-.486-.394-.77-.394-.41 0-.71.233-.71.54.001.265.166.403.738.616v.004c1.085.395 1.405.747 1.405 1.524 0 .944-.695 1.603-1.686 1.603-.725 0-1.254-.289-1.692-.932l.616-.592c.221.422.588.652 1.041.652.426 0 .742-.297.742-.692a.583.583 0 00-.284-.505c-.094-.055-.288-.146-.659-.276-.895-.32-1.203-.664-1.203-1.339 0-.801.659-1.401 1.522-1.401zm4.502-.028c.411 0 .754.087 1.172.3v1.121c-.398-.386-.741-.548-1.195-.549-.895 0-1.597.739-1.598 1.678 0 .991.682 1.687 1.641 1.687.434 0 .77-.154 1.152-.537v1.12c-.434.206-.785.285-1.195.285-1.358 0-2.434-.979-2.564-2.285l-.012-.261c0-1.421 1.155-2.559 2.599-2.559zm16.255.11c1.097 0 1.728.526 1.728 1.442 0 .75-.395 1.24-1.112 1.386l1.538 2.06h-1.171l-1.319-1.961h-.126v1.962h-.951V9.738h1.413zm-26.895-.003c1.546 0 2.624 1.006 2.624 2.447a2.46 2.46 0 01-.888 1.876c-.469.391-1.006.565-1.744.565h-1.393V9.734h1.401zm4.005 4.888h-.952V9.734h.952v4.888zm20.846-4.059h-1.748v1.086h1.685v.829h-1.685v1.318h1.748v.826h-2.703V9.734h2.703v.829zm-25.3 3.23h.255c.616 0 1.002-.119 1.302-.387v-.004c.332-.292.529-.767.529-1.233 0-.465-.197-.923-.529-1.215-.311-.284-.686-.395-1.302-.395h-.255v3.234zm26.882-1.81h.277c.607 0 .93-.275.93-.753s-.323-.726-.915-.727h-.292v1.48zm2.805-2.284a.374.374 0 010 .75.374.374 0 010-.75zm0 .066a.305.305 0 00-.3.308c0 .17.134.308.3.308a.306.306 0 00.296-.308.303.303 0 00-.296-.308zm-.016.091c.103 0 .163.048.163.135h.003c0 .059-.035.102-.094.118l.141.178h-.126l-.122-.166v.166h-.102v-.431h.137zm-.035.193h.02c.051 0 .079-.023.079-.058 0-.036-.028-.056-.079-.056h-.02v.114z",
    fill: "#261F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.506 12.15a2.564 2.564 0 11-5.129 0 2.561 2.561 0 012.564-2.566 2.562 2.562 0 012.565 2.566z",
    fill: "url(#cards_svg__paint0_linear_115_2212)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.506 12.15a2.564 2.564 0 11-5.129 0 2.561 2.561 0 012.564-2.566 2.562 2.562 0 012.565 2.566z",
    fill: "url(#cards_svg__paint1_radial_115_2212)",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.945.733h-33.574c-.655 0-1.183.529-1.183 1.184V22.55c0 .655.528 1.184 1.183 1.184h33.57c.655 0 1.184-.529 1.184-1.184V1.917c0-.655-.529-1.184-1.184-1.184h.004zm-.587 11.5c0 6.13-4.968 11.105-11.099 11.105h-21.888a.792.792 0 01-.789-.79V1.919c0-.435.355-.79.789-.79h21.888c6.127 0 11.099 4.97 11.099 11.105z",
    fill: "url(#cards_svg__paint2_linear_115_2212)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.625,
    y: 1.233,
    width: 34.938,
    height: 22,
    rx: 0.94,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.625,
    y: 1.233,
    width: 34.938,
    height: 22,
    rx: 0.94,
    stroke: "#DEDEDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.121 15.715l3.134-6.964h1.273l3.144 6.964h-1.353l-.692-1.612-.436-1.014-1.309-3.048-1.304 3.047h2.613l.436 1.015h-3.483l-.69 1.612h-1.333zM185.009 15.814a5.293 5.293 0 01-1.562-.229c-.497-.159-.892-.361-1.184-.606l.448-1.005c.278.219.623.401 1.034.547.412.146.833.219 1.264.219.365 0 .66-.04.885-.12.226-.08.391-.185.498-.318a.753.753 0 00.159-.467.626.626 0 00-.229-.508 1.59 1.59 0 00-.597-.308 8.127 8.127 0 00-.806-.219 15.68 15.68 0 01-.885-.229 4.2 4.2 0 01-.806-.348 1.81 1.81 0 01-.587-.577c-.152-.239-.229-.544-.229-.915 0-.378.1-.723.299-1.035.205-.318.514-.57.925-.756.418-.192.945-.288 1.582-.288.417 0 .832.053 1.243.159.411.106.769.259 1.075.457l-.408 1.005a3.712 3.712 0 00-.965-.408 3.542 3.542 0 00-.955-.139c-.358 0-.65.043-.876.13-.219.086-.381.198-.487.338a.797.797 0 00-.149.477.67.67 0 00.218.518c.153.126.349.225.587.298.246.073.518.146.816.219.299.066.594.142.885.229.299.086.568.198.806.338a1.6 1.6 0 01.587.567c.153.239.229.54.229.905 0 .372-.103.716-.308 1.035-.199.311-.508.563-.926.756-.417.185-.945.278-1.581.278zM181.171 13.049v-1.095h-3.362V9.836h3.79V8.75h-5.083v6.964h1.293v-2.666h3.362z",
    fill: "#020621"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210.562,
    y: 1.233,
    width: 34.938,
    height: 22,
    rx: 0.94,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210.562,
    y: 1.233,
    width: 34.938,
    height: 22,
    rx: 0.94,
    stroke: "#DEDEDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.696 15.715l3.133-6.964h1.274l3.143 6.964h-1.353l-.692-1.612-.436-1.014-1.308-3.048-1.304 3.047h2.612l.436 1.015h-3.483l-.689 1.612h-1.333zM227.615 15.814a5.293 5.293 0 01-1.562-.229c-.498-.159-.892-.361-1.184-.606l.448-1.005c.278.219.623.401 1.034.547.411.146.833.219 1.264.219.364 0 .66-.04.885-.12.226-.08.391-.185.497-.318a.748.748 0 00.16-.467.626.626 0 00-.229-.508 1.59 1.59 0 00-.597-.308 8.127 8.127 0 00-.806-.219 15.68 15.68 0 01-.885-.229 4.2 4.2 0 01-.806-.348 1.81 1.81 0 01-.587-.577c-.152-.239-.229-.544-.229-.915 0-.378.1-.723.299-1.035.205-.318.514-.57.925-.756.418-.192.945-.288 1.582-.288.417 0 .832.053 1.243.159.411.106.769.259 1.074.457l-.407 1.005a3.712 3.712 0 00-.965-.408 3.542 3.542 0 00-.955-.139c-.358 0-.65.043-.876.13-.219.086-.381.198-.487.338a.797.797 0 00-.149.477.67.67 0 00.218.518c.153.126.349.225.587.298.246.073.518.146.816.219.299.066.594.142.885.229.299.086.567.198.806.338a1.6 1.6 0 01.587.567c.153.239.229.54.229.905 0 .372-.103.716-.308 1.035-.199.311-.508.563-.926.756-.417.185-.945.278-1.581.278zM224.004 8.751h-1.293v2.875h-3.601V8.751h-1.294v6.964h1.294V12.73h3.601v2.985h1.293V8.75z",
    fill: "#020621"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cards_svg__paint0_linear_115_2212",
    x1: 141.377,
    y1: 9.584,
    x2: 146.509,
    y2: 14.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cards_svg__paint2_linear_115_2212",
    x1: 126.188,
    y1: 0.733,
    x2: 132.113,
    y2: 23.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cards_svg__paint1_radial_115_2212",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45.019 57.006 180.267) scale(3.59464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
export default SvgCards;